import MixPanel from 'mixpanel-browser'

import { config } from 'constants/config'

require('dotenv').config()

MixPanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN, { debug: config.IS_DEV || config.IS_LOCAL })

export default MixPanel